import script from "./Organizers.vue?vue&type=script&setup=true&lang=js"
export * from "./Organizers.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__